<template>
  <div>
    <div class="project-tape-wrap">
      <div class="tape-content">
        <h3 class="title">{{title}}</h3>
        <div class="info">
          <div v-html="info"></div>
          <div v-if="fullUrl" class="audio-wrap">
            <audio :src="fullUrl" controls="controls" style="height:30px;">
              您的浏览器不支持 audio 标签。
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  body{
    background-color: #fff;
  }
</style>
<style scored lang="scss" rel="stylesheet/scss">
  .project-tape-wrap{
    width: 100%;
    background-color: #fff;
    .tape-content{
      padding: 20px;
      line-height: 30px;
      .title{
        color: #00b29c;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        margin-bottom: 20px;
        text-align: center;
      }
      .info{
        font-size: 14px;
        white-space: pre-wrap;
        p{
          white-space: pre-wrap;
        }
        .audio-wrap{
          margin: 20px auto 0;
          text-align: center;
        }
      }
    }
  }
</style>
<script>
  import { getProjectTapeDetail } from "@/api/activity";
  export default {
    data(){
      return {
        id: this.$route.query.id ? this.$route.query.id : "",
        title:'',
        info:'',
        fullUrl:''
      };
    },
    methods:{
      getInfo() {
        // getProjectTapeDetail(this.id).then(res => {
        //   if (res && res.data) {
        //     this.title = res.data.projectName || '猎上网';
        //     this.info = res.data.remark || '';
        //     this.fullUrl = res.data.fileUrl || '';
        //     document.title = this.title;
        //   }
        // }).catch(err=>{});

        let res = {};
        res.data = {
          file: "/20200615/18/593c2313-751a-4e66-b630-ebc68df48a7a.flac",
          fileUrl: "https://ho-test.oss.aliyuncs.com/tdcRecording/20200615/18/593c2313-751a-4e66-b630-ebc68df48a7a.flac?Expires=1907575433&OSSAccessKeyId=4aLE8QGSsmACxcyU&Signature=vQgJmx%2FVUBQMO%2Bz7JmaIvLOUIFw%3D",
          id: 14,
          projectName: "山下智久001-电商组山下智久001-电",
          remark: "付费规则：<br/>雇主做单费率： P6级以下除特殊岗位不支付猎头费用，特殊岗位会在该类岗位的职位公告上进行标注。"
        };
        this.title = res.data.projectName || '猎上网';
        this.info = res.data.remark || '';
        this.fullUrl = res.data.fileUrl || '';
        document.title = this.title;
      }
    },
    created(){
      this.getInfo();
    }
  }
</script>
